import React, { Component } from "react";
import "./index.css";

class NotificationSection extends Component {
  render() {
    return (
      <section id="push-notifications" className="">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center notification-wrap">
              <p className="notification m-0">
                Message space here for latest announcements or advertisments
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default NotificationSection;
